import React from 'react'
import { InputNumber } from 'antd'

import styles from './StyledInputNumber.module.css'

export interface StyledInputNumberProps {
  value: number
  onChange: (value: number | null) => void
  min?: number
  max?: number
  step?: number
  addonBefore?: React.ReactNode
  disabled?: boolean
  style?: React.CSSProperties
}

export const StyledInputNumber: React.FC<StyledInputNumberProps> = ({
  value,
  onChange,
  min,
  max,
  step,
  addonBefore,
  style,
  disabled
}) => {
  return (
    <InputNumber
      disabled={disabled}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      className={styles.input}
      step={step}
      addonBefore={addonBefore}
      style={style}
    />
  )
}
